/** @format */

export const newRequest = {
  data: {
    id: '',
    _client: '',
    _seller: '',
    clientMail: '',
    clientName: '',
    reqChannel: '',
    progress: null,
    seller: '',
    status: 'attiva',
    whZones: [],
    archived: false,
    checked: false,
    reqPartsChecked: 0,
    reqPartsNum: 0,
    optionsAvailable: false,
    carModels: [],
  },
  reqParts: {},
  soldOptions: [],
};

export const newSale = {
  data: {
    _sellerId: null,
    _clientId: null,
    _requestId: null,
    items: {},
    status: 'new',
    shipping: {
      boxes: {},
      _addressId: 0,
      address: null,
      shippingCost: 0,
    },
    notes: null,
    tot: 0,
  },
};

export const newSoldItem = {
  data: {
    _partId: null,
    _optionId: null,
    internalCode: null,
    sync: false,
    price: 0,
  },
};

export const newBox = {
  trackingCode: null,
  trackingLink: null,
  method: null,
  width: 0,
  height: 0,
  depth: 0,
  volume: 0,
  weight: 0,
  taxableVolume: 0,
  price: 0,
};

export const newShipping = {
  boxes: {},
  _addressId: 0,
  address: null,
  shippingCost: 0,
};
